import React from 'react';
import AbstractComponent from '../AbstractComponent';
import Footer from '../layout/footer/Footer';
import ClienteValidarCnpj from './ClienteValidarCnpj';
import Cadastro from './Cadastro';
import ClienteRedirect from './ClienteRedirect';

import UsuarioService from '../../service/UsuarioService';
import AutenticarService from '../../service/AutenticarService';

import { getParam, getAppUrlImg } from '../../helper/Url';

class Register extends AbstractComponent {  
    constructor(props) {
        super(props);
        
        this.state = {
            passo: 1,
            cnpj: ''            
        }

        let cnpj = getParam('cnpj');        

        if((cnpj === null)||(cnpj === ''))
            return ;                        

        this.state.cnpj = cnpj;
    }

    logar(id, email, senha) {                                             
        this.setState({passo: 3});        

        UsuarioService.logar(   
            id,                     
            email, 
            senha                        
        ).then(resposta => {                                                 
            AutenticarService.logar(
                id,
                resposta.data.cnpj,
                resposta.data.token, 
                resposta.data.userName
            );
        });
    }          

    render() {
        return(
            <div id="layoutAuthentication">
                <div id="layoutAuthentication_content">
                    <main>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-7">
                                    <div className="card shadow-lg border-0 rounded-lg mt-5">
                                        <div className="card-header">
                                            <h3 className="text-center font-weight-light my-4">
                                                <img src={getAppUrlImg() + "crie-sua-conta.png"} alt="Login" />
                                            </h3>
                                        </div>

                                        <div className="card-body">                                            
                                            <ClienteValidarCnpj    
                                                cnpj={this.state.cnpj}                                            
                                                visible={this.state.passo === 1}

                                                register={(cnpj) => this.setState({passo: 2, cnpj: cnpj})}
                                            />

                                            <Cadastro
                                                cnpj={this.state.cnpj}

                                                visible={this.state.passo === 2}
                                                login={(id, email, senha) => this.logar(id, email, senha)}
                                            />  

                                            <ClienteRedirect
                                                visible={this.state.passo === 3}
                                            />
                                        </div>

                                        {
                                            this.state.passo < 3 &&
                                            <div className="card-footer text-center">
                                                <div className="small">
                                                    <a onClick={() => this.props.route(
                                                        this.login()
                                                    )}>
                                                        Já tem uma conta? Faça o login
                                                    </a>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

                <div id="layoutAuthentication_footer">
                    <Footer />
                </div>
            </div>
        )
    }
}

export default Register;